import { c as _c } from "react/compiler-runtime";
import { VStack, Heading, Button, Stack, Image, Box, Text, HStack, Avatar, Flex, IconButton, Separator, Badge } from '@chakra-ui/react';
import { Icon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useHover } from '@uidotdev/usehooks';
import React, { useState } from 'react';
import { IoVolumeHighSharp, IoVolumeMute } from 'react-icons/io5';
import { MdOutlinePlayCircleFilled } from 'react-icons/md';
import ReactPlayer from 'react-player';
type VideoHeroCardProps = {
  title?: string;
  slug?: string;
  stepSlug?: string;
  avatar?: string;
  firstName?: string;
  lastName?: string;
  companyLogoUrl?: string;
  videoPreviewUrl?: string;
  video?: string;
  image?: string;
  url?: string;
};
export const VideoHeroCard = props => {
  const $ = _c(88);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [isMuted, setIsMuted] = useState(true);
  const [ref, hovering] = useHover();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([10, 10, 10, 20]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([10, 10, 10, 20]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue(["center", "center", "flex-start"]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== getBreakpointValue) {
    t3 = getBreakpointValue(["center", "center", "space-between"]);
    $[6] = getBreakpointValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Badge size="sm" variant="subtle">Featured</Badge>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== getBreakpointValue) {
    t5 = getBreakpointValue(["center", "center", "flex-start"]);
    $[9] = getBreakpointValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== getBreakpointValue) {
    t6 = getBreakpointValue([4, 4, 4, 8]);
    $[11] = getBreakpointValue;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== getBreakpointValue) {
    t7 = getBreakpointValue(["3xl", "3xl", "3xl", "4xl", "5xl"]);
    $[13] = getBreakpointValue;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== getBreakpointValue) {
    t8 = getBreakpointValue(["center", "center", "left"]);
    $[15] = getBreakpointValue;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = `/videos/${props.slug}`;
  let t10;
  if ($[17] !== props.title || $[18] !== t9) {
    t10 = <NextLink href={t9} prefetch={false}>{props.title}</NextLink>;
    $[17] = props.title;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7 || $[22] !== t8) {
    t11 = <Heading as="h1" size={t7} textAlign={t8}>{t10}</Heading>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== getBreakpointValue) {
    t12 = getBreakpointValue(["sm", "sm", "sm", "sm", "md"]);
    $[24] = getBreakpointValue;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Avatar.Fallback />;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== props.avatar) {
    t14 = <Avatar.Image src={props.avatar} />;
    $[27] = props.avatar;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <Avatar.Root size={t12}>{t13}{t14}</Avatar.Root>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== getBreakpointValue) {
    t16 = getBreakpointValue(["labelMd", "labelMd", "labelMd", "labelMd", "labelLg"]);
    $[32] = getBreakpointValue;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== props.firstName || $[35] !== props.lastName || $[36] !== t16) {
    t17 = <Text textStyle={t16}>{props.firstName} {props.lastName}</Text>;
    $[34] = props.firstName;
    $[35] = props.lastName;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t17) {
    t18 = <HStack flex="1 0 fit-content" gap={3} width="full">{t15}{t17}</HStack>;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Separator height="6" orientation="vertical" />;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== getBreakpointValue || $[43] !== props.companyLogoUrl) {
    t20 = props.companyLogoUrl && <Box h="auto" overflow="hidden" position="relative" width={getBreakpointValue(["6em", "6em", "10em"])}><Image filter={{
        _light: "invert(1)",
        _dark: "invert(0)"
      }} h="100%" objectFit="contain" src={props.companyLogoUrl} w="100%" /></Box>;
    $[42] = getBreakpointValue;
    $[43] = props.companyLogoUrl;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t18 || $[46] !== t20) {
    t21 = <HStack align="center" gap={3}>{t18}{t19}{t20}</HStack>;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t11 || $[49] !== t21 || $[50] !== t5 || $[51] !== t6) {
    t22 = <VStack align={t5} gap={t6}>{t11}{t21}</VStack>;
    $[48] = t11;
    $[49] = t21;
    $[50] = t5;
    $[51] = t6;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== getBreakpointValue) {
    t23 = getBreakpointValue(["md", "md", "md", "lg"]);
    $[53] = getBreakpointValue;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const t24 = `/videos/${props.slug}/${props.stepSlug}?play=1`;
  let t25;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Icon as={MdOutlinePlayCircleFilled} />;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t24) {
    t26 = <NextLink href={t24}>{t25}Start Series</NextLink>;
    $[56] = t24;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t23 || $[59] !== t26) {
    t27 = <Button asChild={true} bgColor="actionActiveSecondary" size={t23}>{t26}</Button>;
    $[58] = t23;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t2 || $[62] !== t22 || $[63] !== t27 || $[64] !== t3) {
    t28 = <VStack align={t2} gap={10} justify={t3} maxWidth="450px" width="full" zIndex={2}>{t4}{t22}{t27}</VStack>;
    $[61] = t2;
    $[62] = t22;
    $[63] = t27;
    $[64] = t3;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  const t29 = props.image;
  let t30;
  if ($[66] !== getBreakpointValue) {
    t30 = getBreakpointValue([true, true, false]);
    $[66] = getBreakpointValue;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== hovering || $[69] !== isMuted || $[70] !== props.image || $[71] !== props.url || $[72] !== props.video) {
    t31 = props.video ? <Box as="div" borderRadius="xl" overflow="hidden" width="full"><NextLink href={props.url || "#"} prefetch={false}><ReactPlayer controls={false} height="auto" loop={true} muted={isMuted} playIcon={<></>} playing={true} url={props.video} volume={isMuted ? 0 : 1} width="100%" /></NextLink></Box> : <Box borderRadius="xl" overflow="hidden" width="full"><NextLink href={props.url || "#"} prefetch={false}><Image src={props.image} transform={hovering && "scale(1.05)"} transition="all 0.2s ease-in-out" /></NextLink></Box>;
    $[68] = hovering;
    $[69] = isMuted;
    $[70] = props.image;
    $[71] = props.url;
    $[72] = props.video;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== isMuted || $[75] !== props.video) {
    t32 = props.video && <Box bottom={0} margin={2} position="absolute" right={0}><IconButton aria-label="mute toggle" variant="subtle" size="md" onClick={() => setIsMuted(_temp)}>{isMuted ? <IoVolumeMute /> : <IoVolumeHighSharp />}</IconButton></Box>;
    $[74] = isMuted;
    $[75] = props.video;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== props.image || $[78] !== ref || $[79] !== t30 || $[80] !== t31 || $[81] !== t32) {
    t33 = <Flex ref={ref} alignItems="flex-end" aspectRatio={1.7777777777777777} backgroundImage={t29} backgroundPosition="center" backgroundRepeat="no-repeat" backgroundSize="cover" borderRadius="xl" boxShadow="0px 5px 20px -10px rgba(0, 0, 0, 0.8)" direction="row" flex={2} height="full" hidden={t30} position="relative" transition="all 0.2s ease-in" width="full">{t31}{t32}</Flex>;
    $[77] = props.image;
    $[78] = ref;
    $[79] = t30;
    $[80] = t31;
    $[81] = t32;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== t0 || $[84] !== t1 || $[85] !== t28 || $[86] !== t33) {
    t34 = <Stack direction="row" gap={10} height="full" justify="center" paddingBottom={5} paddingTop={t0} paddingX={t1} position="relative">{t28}{t33}</Stack>;
    $[83] = t0;
    $[84] = t1;
    $[85] = t28;
    $[86] = t33;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  return t34;
};
function _temp(prevMuted) {
  return !prevMuted;
}